// extracted by mini-css-extract-plugin
export default {"active":"Header_active__OcOMM"};